import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Inside the language-prefixed BrowserRouter (basename = /de or /en),
 * useLocation's pathname is relative to the basename. We normalise for SEO:
 *
 *  - Strip trailing slashes (except root '/'), preventing duplicate
 *    indexing of e.g. '/about' vs '/about/'.
 *  - Redirect legacy WordPress paths (still indexed by Google) to their
 *    current equivalents, avoiding soft-404s on old, linked content.
 *
 * Unprefixed URLs are handled by LanguageGate BEFORE this component mounts.
 */
const LEGACY_REDIRECTS = [
  { match: /^\/project\/.*/, to: '/portfolio' },
  { match: /^\/wp-(content|admin|login|includes|json)\/?.*/, to: '/' },
  { match: /^\/author\/.*/, to: '/about' },
  { match: /^\/category\/.*/, to: '/produktkatalog' },
  { match: /^\/tag\/.*/, to: '/produktkatalog' }
];

export function RouteNormalizer() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;

    for (const rule of LEGACY_REDIRECTS) {
      if (rule.match.test(pathname)) {
        navigate(rule.to, { replace: true });
        return;
      }
    }

    if (pathname.length > 1 && pathname.endsWith('/')) {
      navigate(pathname.slice(0, -1) + search + hash, { replace: true });
    }
  }, [location, navigate]);

  return null;
}
